import axios from '@/utils/axios'
import {getBackendByRole} from '@/utils/role'

/**
 * 保存文件对象及文件信息
 * @param formData
 * @returns {AxiosPromise}
 */
export const saveFile = (formData) => {
  return axios({
    url: `${getBackendByRole()}/file/saveFile`,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: formData
  })
}

/**
 * 保存文件信息
 * @param form
 * @returns {AxiosPromise}
 */
export const saveFileInfo = (form) => {
  return axios({
    url: `${getBackendByRole()}/file/saveFileInfo`,
    method: 'post',
    data: form
  })
}

/**
 * 获取文件信息
 * @param id 文件对象uuid或key
 * @returns {AxiosPromise}
 */
export const getFileInfo = (id) => {
  return axios({
    url: `${getBackendByRole()}/file/getFileInfo`,
    method: 'get',
    params: {
      id: id
    }
  })
}

/**
 * 获取文件信息
 * @param ids 文件对象uuid或key
 * @returns {AxiosPromise}
 */
export const getFileInfos = (ids) => {
  return axios({
    url: `${getBackendByRole()}/file/getFileInfos`,
    method: 'post',
    data: ids
  })
}

/**
 * 获取临时授权访问
 */
export const getSecurityToken = () => {
  return axios({
    url: `${getBackendByRole()}/file/getSecurityToken`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/common/ossFile.js